/**
 * SmartEmailing webtracking - snapshot košíku (event smartemailing_cart) z JSON odpovědi AJAX akcí košíku.
 * Payload sestavuje server, na kanálu bez konfigurace v odpovědi chybí.
 */
window.s31SmartEmailingCartPush = function (payload) {
	if (!payload) {
		return;
	}

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(payload);
};
